import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setFavVideos } from '@/store/slices/dashboard/favVideosSlice';
import { RootState } from '@/store/index';
import { getFavVideosApiCall } from '@/services/api';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import HistoryFavLoader from '@/pages/dashboard/loaders/historyFavLoader'
import './fav.css';
import { addCurrentThemeClassToEle } from '@/utils';

export default function Fav(props: any) {
    const navigate = useNavigate();
    const { dashboard } = useLocalTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [visibleCount, setVisibleCount] = useState(4); // Show 4 videos at a time

    const dispatch = useDispatch();
    const favVideos = useSelector((state: RootState) => state.favVideosReducer.favVideos);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    const noDataRef = useRef<HTMLDivElement>(null);

    const getFavVideos = async () => {
        dispatch(setFavVideos([])); // to handle the continer auto scale when page loads
        const favVideosDetails = await getFavVideosApiCall();
        if (favVideosDetails.data && favVideosDetails.status) {
            setIsLoading(false);
            dispatch(setFavVideos(favVideosDetails.data));
            // dispatch(setFavVideos([])); // For testing empty state
        }
    };

    useEffect(() => {
        if (props.activeKey && props.activeKey === "favorite") {
            if (favVideos.length === 0) {
                getFavVideos();
            } else {
                setIsLoading(false)
            }
        }
    }, [props.activeKey, isLoading]);

    useEffect(() => {
        if (favVideos.length === 0 && noDataRef.current) {
            noDataRef.current.style.height = `${window.innerHeight - 120}px`;
        }
    }, [favVideos])

    const handleLoadMore = () => {
        setVisibleCount((prev) => prev + 4);
    };

    // Flatten videos with their corresponding date
    const flattenedVideos = favVideos.flatMap((entry: any) =>
        (entry.videos || []).map((video: any) => ({
            ...video,
            date: entry.date,
        }))
    );

    const redirectToVidePage = (video: any) => {
        if (!(video.seriesId || video._id)) {
            console.log("issue in redirectToVidePage");
            return;
        }

        const seriesId = video.seriesId;
        const videoDocId = video._id;
        const isWelcomeSeries = Boolean(
            video.isWelcomeSeries === true || video.isWelcomeOfferVideo === true
        );
        const asSubscribedSeries = Boolean(
            video.isSubscribedSeries === true || video.isSubscribedVideo === true
        );

        let navigate_ = `/watch?video=${videoDocId}`;
        if (seriesId) {
            if (asSubscribedSeries) {
                navigate_ = `/watch?series=${seriesId}`;
                if (videoDocId) {
                    navigate_ += `&video=${videoDocId}`;
                }
                if (isWelcomeSeries) {
                    navigate_ += "&ws=true";
                }
                navigate_ += "&subscription=true";
            } else {
                navigate_ = `/watch?series=${seriesId}&video=${videoDocId}`;
                if (isWelcomeSeries) {
                    navigate_ += "&ws=true";
                }
            }
        }

        navigate(navigate_, {
            state: {
                source: `/`,
                openVideoDirectly: true,
            },
        });
    }


    return (
        <div className={`favViewMain ${addCurrentThemeClassToEle(currentTheme, 'favViewMain')}`}>
            {isLoading ? (
                // {true ? ( // testing
                <HistoryFavLoader
                    type="favVideos"
                />
            ) : (
                flattenedVideos.length > 0 ? (
                    <>
                        {flattenedVideos.slice(0, visibleCount).map((video: any, index: number) => (
                            <div
                                onClick={() => redirectToVidePage(video)}
                                key={index}>
                                {/* {(index === 0 || video.date !== flattenedVideos[index - 1].date) && (
                                    <p className='favVideoDate'>{video.date}</p>
                                )} */}
                                <Link to="/" className='flex items-center mb-[25px] max-[1200px]:mb-[20px] max-[450px]:mb-[18px]'>
                                    <img className='hfVideoThumbnail' src={video.thumbnailUrl} alt='favThumbnail' />
                                    <p className='favVideoTitle'>{video.title}</p>
                                </Link>
                            </div>
                        ))}

                        {visibleCount < flattenedVideos.length && (
                            <div className="flex justify-center my-6">
                                <button
                                    onClick={handleLoadMore}
                                    className="loadMoreBtn w-[150px] h-[40px] max-[500px]:w-[120px] max-[500px]:h-[30px] text-[16px] max-[500px]:text-[15px] rounded-[5px] transition"
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                    </>
                ) : (
                    <div
                        ref={noDataRef}
                        className='noHistoryVideoCon text-[#949494] flex items-center justify-center'
                    >
                        <p>{dashboard.favVideosSection.noVideoText}</p>
                    </div>
                )
            )}
        </div>
    );
}
